"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderNearbyFilter = void 0;
var DetailPopupNearbyMyPlace_1 = require("@/pages/detail/components/DetailPopupNearbyMyPlace");
var DetailPopupNearbyProperties_1 = require("@/pages/detail/components/DetailPopupNearbyProperties");
var DetailPopNearbyTabType_1 = require("@/pages/detail/states/DetailPopNearbyTabType");
var classnames_1 = require("classnames");
var React = require("react");
var DetailPopupNearbyResultItems_1 = require("./DetailPopupNearbyResultItems");
exports.renderNearbyFilter = function (props) {
    var getItemClass = function (type) {
        return classnames_1.default([
            'c-propmap__type',
            {
                'c-propmap__type--active': type === props.popNearbyTab,
            },
        ]);
    };
    var renderPoiBody = function (props) {
        switch (props.popNearbyTab) {
            case DetailPopNearbyTabType_1.DetailPopNearbyTabType.MYPLACE: {
                return DetailPopupNearbyMyPlace_1.renderMyPlaces(props);
            }
            case DetailPopNearbyTabType_1.DetailPopNearbyTabType.PROPERTIES: {
                return DetailPopupNearbyProperties_1.renderNearbyProperties(props);
            }
            case DetailPopNearbyTabType_1.DetailPopNearbyTabType.FAVORITES: {
                return DetailPopupNearbyProperties_1.renderNearbyProperties(props);
            }
            case DetailPopNearbyTabType_1.DetailPopNearbyTabType.HISTORY: {
                return DetailPopupNearbyProperties_1.renderNearbyProperties(props);
            }
            case DetailPopNearbyTabType_1.DetailPopNearbyTabType.NONE: {
                return null;
            }
        }
        return DetailPopupNearbyResultItems_1.renderResultItems(props);
    };
    return (React.createElement("div", { className: "c-poi" },
        React.createElement("div", { className: "c-poi__handle" }),
        React.createElement("div", { className: "c-poi__nav" },
            React.createElement("div", { className: "c-propmap__types c-propmap__types--rel" },
                React.createElement("div", { onClick: function () { return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.MYPLACE); }, className: getItemClass(DetailPopNearbyTabType_1.DetailPopNearbyTabType.MYPLACE) },
                    React.createElement("span", { className: "c-propmap__icon", style: { backgroundColor: '#085963' } }),
                    props.t.myPlaces),
                React.createElement("div", { onClick: function () {
                        return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.PROPERTIES);
                    }, className: getItemClass(DetailPopNearbyTabType_1.DetailPopNearbyTabType.PROPERTIES) },
                    React.createElement("span", { className: "c-propmap__icon", style: { backgroundColor: '#6b3135' } }),
                    props.t.nearbyProperties),
                React.createElement("div", { onClick: function () { return props.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.SCHOOL); }, className: getItemClass(DetailPopNearbyTabType_1.DetailPopNearbyTabType.SCHOOL) },
                    React.createElement("span", { className: "c-propmap__icon", style: { backgroundColor: '#4971c5' } }),
                    props.t.schools),
                React.createElement("div", { onClick: function () { return props.onMoreClick(); }, className: getItemClass(null) },
                    React.createElement("span", { className: "c-propmap__icon", style: { backgroundColor: '#999' } }),
                    props.t.more))),
        React.createElement("div", { className: "c-poi__body" }, renderPoiBody(props))));
};
